module.exports = __webpack_public_path__ + "img/ATeilGruppeGroß.7b326217.jpg";